module.exports = __webpack_public_path__ + "img/mook-icon.a9ce29b4.png";